<template>
    <li v-if="classes.large">
        <a
            :class="classes"
            class="no-top-bottom-padding"
        >
            <span
                class="button small white margin"
                @click="toggleSearchBar"
            >
                <span class="icon-search" />
            </span>
        </a>
    </li>
</template>
<script>
export default {
    name: 'SearchElement',
    props: {
        classes: {
            type: [Object, String],
            default() {
                return '';
            }
        }
    },
    methods: {
        toggleSearchBar() {
            this.$store.dispatch('search/toggleBar');
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../header';
 .large {
    .padding-lr {
        padding: 0 $function-menu-padding-lr;
    }

    .no-top-bottom-padding {
        padding: 0 $function-menu-padding-bottom-large;
    }

    .function-menu {
        line-height: $menu-line-height;
    }

    .margin {
        margin :0;
    }
}

.small {
    .padding-lr {
        padding: 0 $function-menu-padding-lr;
    }

    .no-top-bottom-padding {
        padding: 0 $function-menu-padding-bottom-small;
    }

    .function-menu {
        line-height: $menu-line-height;
    }
}
</style>
